import React from 'react';
import { Box, Grid } from '@mui/material';
import { LineChart, Line, AreaChart, Area, XAxis, YAxis, Tooltip, BarChart, Bar, CartesianGrid, Legend } from 'recharts';
import KPIGrid from '../components/KPIGrid';
import ChartCard from '../components/ChartCard';
import DataTable from '../components/DataTable';

const MonetizationTab = ({ data }) => {
    if (!data) return <div>Loading...</div>;

    const { kpis, startsSeries, cancelsSeries, revenueByPlan, events } = data;

    return (
        <Box height="100%">
            <KPIGrid kpis={kpis} />

            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <ChartCard title="Subscriptions vs Cancels">
                        <AreaChart data={startsSeries}>
                            <defs>
                                <linearGradient id="colorStarts" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8}/>
                                    <stop offset="95%" stopColor="#8884d8" stopOpacity={0}/>
                                </linearGradient>
                            </defs>
                            <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                            <XAxis dataKey="date" tickFormatter={(str) => {
                                const date = new Date(str);
                                return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
                            }} minTickGap={30} />
                            <YAxis />
                            <Tooltip labelFormatter={(label) => new Date(label).toDateString()} />
                            <Legend />
                            <Area type="monotone" dataKey="value" stroke="#8884d8" fillOpacity={1} fill="url(#colorStarts)" name="New Subscriptions" dot={false} />
                        </AreaChart>
                    </ChartCard>
                </Grid>
                <Grid item xs={12} md={6}>
                    <ChartCard title="Revenue by Plan">
                        <BarChart data={revenueByPlan}>
                             <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                             <XAxis dataKey="plan" />
                             <YAxis />
                             <Tooltip formatter={(val) => `$${val}`} />
                             <Legend />
                             <Bar dataKey="value" fill="#82ca9d" name="Revenue" />
                        </BarChart>
                    </ChartCard>
                </Grid>
                <Grid item xs={12}>
                    <DataTable rows={events} />
                </Grid>
            </Grid>
        </Box>
    );
};

export default MonetizationTab;
